import { Component, ViewContainerRef, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { FundraisingPurchaseInfo, TicketOrderTableView } from '../../_models/fundraising/TicketOrder';
import { Cue5050Service } from '../../_services/fundraising/cue5050.service';
import { FundraisingService } from '../../_services/fundraising/fundraising.service';
import { DialogService } from '../../_services/dialog.service';
import { Cue5050 } from '../../_models/fundraising/Cue5050';
import { forkJoin } from 'rxjs';
import { SavedReport } from '../../_models/fundraising/reports/SavedReport';
import { FundraisingReportService } from '../../_services/fundraising/fundraisingReport.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'saved-reports',
    templateUrl: './saved-reports.component.html',
    styleUrls: ['../../_shared/base.management.component.css']
  })

export class SavedReportsComponent implements OnInit {

    public reports: SavedReport[] = [];
    public filteredReports: SavedReport[] = [];

    public searchText: string;

    constructor(
        private reportService: FundraisingReportService,
        private spinner: NgxSpinnerService,
        private dialogService: DialogService,
        private router: Router,
        private route: ActivatedRoute,
        private viewRef: ViewContainerRef
    ){}

    ngOnInit(){
        this.spinner.show();
        this.reportService.getSavedReports()
            .subscribe(data => {
                this.spinner.hide();
                this.reports = data;
                this.filteredReports = data;
            }, error => {
                this.spinner.hide();
                this.dialogService.alert("Uh oh!", "Something went wrong trying to get your saved reports.", this.viewRef);
            })
    }

    viewReport(report: SavedReport) {
        this.reportService.eventIds = report.eventIds;
        this.reportService.reportType = report.reportType;
        this.reportService.breakdownType = report.breakdownType;
        this.router.navigate(['view'], {relativeTo: this.route});
    }

    searchReports(){
        if (!this.searchText) {
            this.filteredReports = this.reports;
            return;
        }

        const search = this.searchText.toLowerCase();

        this.filteredReports = this.reports.filter(r => 
            (r.name ? r.name.toLowerCase().indexOf(search) !== -1 : false) ||
            (r.reportType ? this.reportService.getReportTypeDescription(r.reportType).toLowerCase().indexOf(search) !== -1 : false) ||
            (r.breakdownType ? this.reportService.getBreakdownDescription(r.breakdownType).toLowerCase().indexOf(search) !== -1 : false) ||
            (r.dateSaved ? r.dateSaved.toString().toLowerCase().indexOf(search) : false) !== -1 ||
            !search)
    }
}